/* Shiro Drip — carrusel corto de reseñas en la ficha de producto */
(function () {
  function montar(root) {
    if (root.dataset.montado === 'true') return;
    root.dataset.montado = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mini-slide]'));
    if (slides.length < 2) return;

    var dotsBox = root.querySelector('[data-mini-dots]');
    var intervalo = parseInt(root.dataset.interval, 10) || 5000;
    var actual = 0;
    var temporizador = null;
    var dots = [];

    var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function mostrar(i) {
      actual = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === actual); });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === actual);
        d.setAttribute('aria-current', n === actual ? 'true' : 'false');
      });
    }

    function arrancar() {
      if (sinMovimiento) return;
      parar();
      temporizador = setInterval(function () { mostrar(actual + 1); }, intervalo);
    }

    function parar() {
      if (temporizador) { clearInterval(temporizador); temporizador = null; }
    }

    if (dotsBox) {
      slides.forEach(function (_, n) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'sd-mini__dot' + (n === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Reseña ' + (n + 1));
        d.addEventListener('click', function () { mostrar(n); arrancar(); });
        dotsBox.appendChild(d);
        dots.push(d);
      });
    }

    // Se pausa al pasar por encima o al enfocar con teclado
    root.addEventListener('mouseenter', parar);
    root.addEventListener('mouseleave', arrancar);
    root.addEventListener('focusin', parar);
    root.addEventListener('focusout', arrancar);

    // Y también si la pestaña deja de estar visible
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { parar(); } else { arrancar(); }
    });

    mostrar(0);
    arrancar();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-mini-reviews]').forEach(montar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
